// Loads the Quaternius characters and replaces the procedural people once the models arrive.
import { worldReady } from '../../ui/splash.js';
import { loadCharacterModels } from './loader.js';
import { buildRetargeting } from './retarget.js';
import { buildAnimations } from './animation.js';
import { prepareCharacters } from './prepared.js';
import { buildOutfits } from './outfits.js';
import { dressWalkers } from './accessories.js';
import { buildSeating } from './seating.js';
import { buildRider } from './rider.js';
import { buildProps } from './props.js';
import { placeSitters } from './activities.js';
import { buildBeachPeople } from './beach-people.js';
import { buildVolleyball } from './volleyball.js';
import {
  dressPolyforkWalkers,
  loadPolyforkBeach,
  loadPolyforkPeople,
  placePolyforkBeach,
  placePolyforkSitters,
} from './polyfork.js';

export function buildCharacters() {
  (async () => {
    // Polyfork people load alongside; if they fail, the walkers keep their Quaternius models
    const city = loadPolyforkPeople().catch((e) =>
      console.warn('city people not loaded, keeping the walkers', e),
    );
    const beach = loadPolyforkBeach().catch((e) =>
      console.warn('beach people not loaded, keeping the beach', e),
    );
    try {
      await loadCharacterModels();
      buildRetargeting();
      buildAnimations();
      prepareCharacters();
      buildOutfits();
      dressWalkers();
      buildSeating();
      buildRider();
      buildProps();
      placeSitters();
      buildBeachPeople();
      buildVolleyball();
      const people = await city;
      if (people) {
        dressPolyforkWalkers(people);
        placePolyforkSitters(people);
      }
      const sand = await beach;
      if (sand) {
        dressPolyforkWalkers(sand, true);
        placePolyforkBeach(sand);
      }
    } catch (e) {
      console.warn('characters not loaded, keeping procedural people', e);
    }
    worldReady();
  })();
}
